import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ClauseLibraryFeature } from './selectors';
import {
  BatchUpdateClauseDto,
  ClauseDto,
  CreateClauseDto,
  GetClauseDto,
  UpdateClauseDto,
} from '../models/clauses.model';

export const ClauseLibraryActions = createActionGroup({
  source: ClauseLibraryFeature,
  events: {
    'Get Clauses': emptyProps(),
    'Load Clauses Fail': emptyProps(),
    'Load Clauses': emptyProps(),
    'Set Clauses': props<{ clauses: GetClauseDto[] }>(),
    'Create Clause': props<{ model: CreateClauseDto }>(),
    'Create Clause Success': props<{ clause: GetClauseDto }>(),
    'Create Clause Fail': emptyProps(),
    'Create Clause Cancel': props<{ pristine: boolean }>(),
    'Create Clause Cancelled': emptyProps(),
    'Clear Create Clause Cancelled': emptyProps(),
    'Close Creating Clause Modal': emptyProps(),
    'Delete Clause': props<{ uniqueId: string }>(),
    'Delete Clause Confirmed': props<{ uniqueId: string }>(),
    'Delete Clause Success': emptyProps(),
    'Delete Clause Fail': emptyProps(),
    'Delete Clause Cancel': emptyProps(),
    'Update Clauses': props<{ clauses: BatchUpdateClauseDto[] }>(),
    'Update Clauses Success': emptyProps(),
    'Update Clauses Fail': emptyProps(),
    'Delete Clauses': props<{ uniqueIds: string[] }>(),
    'Delete Clauses Confirmed': props<{ uniqueIds: string[] }>(),
    'Delete Clauses Success': emptyProps(),
    'Delete Clauses Fail': emptyProps(),
    'Delete Clauses Cancel': emptyProps(),
    'Load Clause': props<{ uniqueId: string }>(),
    'Load Clause Fail': emptyProps(),
    'Set Clause': props<{ clause: GetClauseDto }>(),
    'Edit Clause': props<{ model: UpdateClauseDto; uniqueId: string }>(),
    'Edit Clause Success': props<{ clause: GetClauseDto }>(),
    'Edit Clause Fail': emptyProps(),
    'Edit Clause Cancel': props<{ pristine: boolean }>(),
    'Edit Clause Cancelled': emptyProps(),
    'Clear Edit Clause Cancelled': emptyProps(),
    'Close Editing Clause Modal': emptyProps(),
  },
});
